<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="square-jelly-box" [fullScreen]="true">
    <p class="loading-text">Loading...</p>
  </ngx-spinner>
<router-outlet></router-outlet>
